import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ScrollText, RefreshCw, Loader2 } from "lucide-react";

const ACTION_LABELS = {
  generate_codes: "Codici generati",
  update_code: "Codice modificato",
  reset_device: "Dispositivo resettato",
  revoke_code: "Codice revocato",
  delete_code: "Codice eliminato",
};

function fmt(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export default function AuditLog() {
  const [logs, setLogs] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    api.get("/admin/audit").then((r) => setLogs(r.data)).catch(() => toast.error("Errore caricamento log")).finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <div data-testid="audit-log" className="bg-black border border-amber-500/15 rounded-md p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="font-mono-data text-xs text-amber-400/80 tracking-widest uppercase flex items-center gap-2">
          <ScrollText className="w-3.5 h-3.5" /> Registro Attività (Audit)
        </h3>
        <button
          data-testid="audit-refresh-button"
          onClick={load}
          className="flex items-center gap-1 text-[10px] font-mono-data uppercase text-slate-400 border border-slate-600/50 rounded-sm px-2 py-1 hover:text-amber-300 hover:border-amber-500/40 transition-colors"
        >
          <RefreshCw className="w-3 h-3" /> Aggiorna
        </button>
      </div>
      {loading || logs === null ? (
        <p className="font-mono-data text-xs text-amber-500/60 flex items-center gap-2">
          {loading && <Loader2 className="w-3 h-3 animate-spin" />} CARICAMENTO…
        </p>
      ) : logs.length === 0 ? (
        <p className="text-xs text-slate-600">Nessuna attività registrata.</p>
      ) : (
        <div className="overflow-x-auto max-h-72 overflow-y-auto">
          <table className="w-full min-w-[520px]">
            <thead>
              <tr>
                {["Quando", "Azione", "Target", "Dettaglio", "IP"].map((h) => (
                  <th key={h} className="text-left font-mono-data text-[10px] text-amber-400/70 uppercase tracking-widest px-2 py-1.5 sticky top-0 bg-black">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-t border-amber-500/[0.06]">
                  <td className="px-2 py-1.5 font-mono-data text-[11px] text-slate-500 whitespace-nowrap">{fmt(l.created_at)}</td>
                  <td className="px-2 py-1.5 text-xs text-amber-200">{ACTION_LABELS[l.action] || l.action}</td>
                  <td className="px-2 py-1.5 font-mono-data text-[11px] text-slate-300">{l.target || "—"}</td>
                  <td className="px-2 py-1.5 text-[11px] text-slate-500">
                    {l.meta && Object.keys(l.meta).length ? Object.entries(l.meta).map(([k, v]) => `${k}: ${v}`).join(" · ") : "—"}
                  </td>
                  <td className="px-2 py-1.5 font-mono-data text-[10px] text-slate-600">{l.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
